/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Unit_Suffix_YearInputs */

const cs_price_unit_suffix_year = /** @type {(inputs: Price_Unit_Suffix_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/rok`)
};

const en_price_unit_suffix_year = /** @type {(inputs: Price_Unit_Suffix_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/yr`)
};

/**
* | output |
* | --- |
* | "/yr" |
*
* @param {Price_Unit_Suffix_YearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const price_unit_suffix_year = /** @type {((inputs?: Price_Unit_Suffix_YearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Unit_Suffix_YearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_unit_suffix_year(inputs)
	return cs_price_unit_suffix_year(inputs)
});